import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import { useStyleStore } from "@bloglovin/vue-component-library";
import useDynamicComponentStore from "%/stores/dynamic-component-store";

export default class BoxShadow extends BaseOption {
  static userInterfaceComponent = {
    label: "Box Shadow",
    component: inspectorTools.SHADOW_PICKER,
    useCustomLabel: true,
    useVerticalOrientation: true,
    useDefaultVariableLinking: false,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      multiple: true,
      title: "Box Shadow",
      schema: {
        fields: {
          color: true,
          blur: true,
          offsetX: true,
          offsetY: true,
          spread: true,
          inset: true,
        },
        defaultShadow() {
          return {
            color: { value: "standard", source: "theme.border" },
            blur: 2,
            offsetX: 2,
            offsetY: 2,
            spread: 2,
            inset: false,
          };
        },
      },
    },
  };

  static defaultValue = [];

  static convertConfigValueToCompiledValue(configValue, themeId) {
    let boxShadowStrings = [];

    if (!configValue) {
      return "";
    }

    if (themeId === undefined || themeId === null) {
      themeId = useDynamicComponentStore().themeId;
    }

    configValue.forEach(shadow => {
      let shadowString = "";

      if (shadow.inset) {
        shadowString += "inset";
      }

      ["offsetX", "offsetY", "blur", "spread"].forEach(prop => {
        const formatted = this.formatShadowValue(shadow[prop]);
        shadowString += ` ${formatted}px`;
      });

      if (shadow.color !== null) {
        shadowString += ` ${BoxShadow.getBoxShadowColor(shadow.color, themeId)}`;
      }

      boxShadowStrings.push(shadowString);
    });

    return boxShadowStrings.join(",") || "none";
  }

  static getBoxShadowColor(option, themeId, themeMode = "inherit") {
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];
    if (option.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(option, styleStore.themes[themeId], palette, themeId, themeMode);
  }
}
